export default "__VITE_ASSET__b450b0ce__"